import { render, staticRenderFns } from "./underwriting.vue?vue&type=template&id=0b07cb81&scoped=true&"
import script from "./underwriting.vue?vue&type=script&lang=js&"
export * from "./underwriting.vue?vue&type=script&lang=js&"
import style0 from "./underwriting.vue?vue&type=style&index=0&id=0b07cb81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07cb81",
  null
  
)

export default component.exports